import React from 'react';
import { Button, Form, Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { changePassword } from 'state/internalToolsUser/actions';
import ValidatedFormInput from 'components/ValidatedFormInput';
import { connect } from 'react-redux';
import { SemanticToastContainer } from 'react-semantic-toasts';
import validator from 'validator';

const requiredValidation = (value = '') =>
  !validator.isEmpty(value) ? undefined : 'This field is required';

const passwordMustMatch = (value, allValues) =>
  value !== allValues.newPassword ? 'Passwords do not match' : undefined;

class ChangePasswordPage extends React.Component {
  onSubmit = ({ oldPassword, newPassword }) => {
    const { dispatch } = this.props;
    dispatch(changePassword(oldPassword, newPassword));
  };

  render() {
    const { handleSubmit } = this.props;
    return (
      <>
        <SemanticToastContainer position="top-right" />
        <h1>Change Password</h1>
        <br />
        <Grid>
          <Grid.Column width={8}>
            <Form onSubmit={handleSubmit(this.onSubmit)}>
              <Field
                id="oldPassword"
                name="oldPassword"
                component={ValidatedFormInput}
                placeholder="Old Password"
                type="password"
                autoFocus
                validate={requiredValidation}
              />
              <Field
                id="newPassword"
                name="newPassword"
                component={ValidatedFormInput}
                placeholder="New Password"
                type="password"
                validate={requiredValidation}
              />
              <Field
                id="confirmPassword"
                name="confirmPassword"
                component={ValidatedFormInput}
                placeholder="Confirm New Password"
                type="password"
                validate={[requiredValidation, passwordMustMatch]}
              />
              <Button type="submit" fluid primary>
                Change Password
              </Button>
            </Form>
          </Grid.Column>
        </Grid>
      </>
    );
  }
}

ChangePasswordPage.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(
  reduxForm({
    form: 'changePassword',
  })(ChangePasswordPage)
);
